import { useState } from 'react';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import { CopyButton } from '@/components/ui/CopyButton';
import './SecretValue.css';

interface SecretValueProps {
  /** What the value is: "Password". Shown beside it and used on the copy button. */
  label: string;
  value: string;
  /**
   * A secret starts hidden, so it is safe on a shared screen, and gets a show
   * and hide button. A plain value, like a username, is always shown.
   */
  secret?: boolean;
}

/** One value a person needs to read or paste somewhere: shown in mono, with a copy button. */
export function SecretValue({ label, value, secret = false }: SecretValueProps) {
  const [shown, setShown] = useState(!secret);
  const name = label.toLowerCase();

  return (
    <div className="secret-value">
      <span className="secret-value__label">{label}</span>
      <span className="secret-value__box">
        <code className="secret-value__text">{shown ? value : '•'.repeat(12)}</code>
        {secret && (
          <button
            type="button"
            className="secret-value__toggle"
            onClick={() => setShown((s) => !s)}
            aria-pressed={shown}
            aria-label={shown ? `Hide ${name}` : `Show ${name}`}
          >
            {shown ? <EyeSlash aria-hidden="true" /> : <Eye aria-hidden="true" />}
            {shown ? 'Hide' : 'Show'}
          </button>
        )}
        <CopyButton value={value} label={`Copy ${name}`} />
      </span>
    </div>
  );
}

export default SecretValue;
